var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1658_5038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2598 16.1054H1.84544C0.827429 16.1054 0 15.278 0 14.26V3.1876C0 2.16959 0.827429 1.34229 1.84544 1.34229H14.2598C15.2778 1.34229 16.1053 2.16959 16.1053 3.1876V14.26C16.1053 15.278 15.2778 16.1054 14.2598 16.1054ZM1.84544 2.34886C1.38306 2.34886 1.00658 2.72523 1.00658 3.1876V14.26C1.00658 14.7223 1.38306 15.0988 1.84544 15.0988H14.2598C14.7222 15.0988 15.0987 14.7223 15.0987 14.26V3.1876C15.0987 2.72523 14.7222 2.34886 14.2598 2.34886H1.84544Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.602 6.37523H0.503289C0.225473 6.37523 0 6.14976 0 5.87194C0 5.59413 0.225473 5.36865 0.503289 5.36865H15.602C15.8798 5.36865 16.1053 5.59413 16.1053 5.87194C16.1053 6.14976 15.8798 6.37523 15.602 6.37523Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86071 4.02632C3.58289 4.02632 3.35742 3.80084 3.35742 3.52303V0.503289C3.35742 0.225473 3.58289 0 3.86071 0C4.13853 0 4.364 0.225473 4.364 0.503289V3.52303C4.364 3.80084 4.13853 4.02632 3.86071 4.02632Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2455 4.02632C11.9677 4.02632 11.7422 3.80084 11.7422 3.52303V0.503289C11.7422 0.225473 11.9677 0 12.2455 0C12.5233 0 12.7488 0.225473 12.7488 0.503289V3.52303C12.7488 3.80084 12.5233 4.02632 12.2455 4.02632Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7377,
    cy: 13.7367,
    r: 3.31579,
    fill: "white",
    stroke: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52076 8.42042H10.4473C10.7543 8.42042 11.0032 8.17152 11.0032 7.86451C11.0032 7.55749 10.7543 7.30859 10.4473 7.30859H9.52076C9.21374 7.30859 8.96484 7.55749 8.96484 7.86451C8.96484 8.17152 9.21374 8.42042 9.52076 8.42042Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1504 7.30859H6.22388C5.91687 7.30859 5.66797 7.55749 5.66797 7.86451C5.66797 8.17152 5.91687 8.42042 6.22388 8.42042H7.1504C7.45742 8.42042 7.70632 8.17152 7.70632 7.86451C7.70632 7.55749 7.45742 7.30859 7.1504 7.30859Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8215 8.42042H13.7481C14.0551 8.42042 14.304 8.17152 14.304 7.86451C14.304 7.55749 14.0551 7.30859 13.7481 7.30859H12.8215C12.5145 7.30859 12.2656 7.55749 12.2656 7.86451C12.2656 8.17152 12.5145 8.42042 12.8215 8.42042Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85158 9.81006H2.92505C2.61804 9.81006 2.36914 10.059 2.36914 10.366C2.36914 10.673 2.61804 10.9219 2.92505 10.9219H3.85158C4.15859 10.9219 4.40749 10.673 4.40749 10.366C4.40749 10.059 4.15859 9.81006 3.85158 9.81006Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1504 9.81006H6.22388C5.91687 9.81006 5.66797 10.059 5.66797 10.366C5.66797 10.673 5.91687 10.9219 6.22388 10.9219H7.1504C7.45742 10.9219 7.70632 10.673 7.70632 10.366C7.70632 10.059 7.45742 9.81006 7.1504 9.81006Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0032 10.366C11.0032 10.059 10.7543 9.81006 10.4473 9.81006H9.52076C9.21374 9.81006 8.96484 10.059 8.96484 10.366C8.96484 10.673 9.21374 10.9219 9.52076 10.9219H10.4473C10.7543 10.9219 11.0032 10.673 11.0032 10.366Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85158 12.312H2.92505C2.61804 12.312 2.36914 12.5609 2.36914 12.8679C2.36914 13.1749 2.61804 13.4238 2.92505 13.4238H3.85158C4.15859 13.4238 4.40749 13.1749 4.40749 12.8679C4.40749 12.5609 4.15859 12.312 3.85158 12.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1504 12.312H6.22388C5.91687 12.312 5.66797 12.5609 5.66797 12.8679C5.66797 13.1749 5.91687 13.4238 6.22388 13.4238H7.1504C7.45742 13.4238 7.70632 13.1749 7.70632 12.8679C7.70632 12.5609 7.45742 12.312 7.1504 12.312Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7383 11.8418V13.5365C13.7383 13.647 13.8278 13.7365 13.9383 13.7365H15.633",
    stroke: "#202020",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1658_5038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulesIcon);
export default __webpack_public_path__ + "static/media/schedules-icon.0b84e6edf9ff69795045882fb8b56aa0.svg";
export { ForwardRef as ReactComponent };